import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-23825c40"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pathway-modal-content"
}
const _hoisted_2 = { class: "text-center modal-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Click 'Send' and all team members will be notified.", -1))
const _hoisted_4 = { class: "notification-text" }
const _hoisted_5 = { class: "button-container" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_8 = {
  key: 1,
  class: "pathway-modal-content"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center modal-header" }, "Sent!", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lottie-container" }, [
  /*#__PURE__*/_createElementVNode("lottie-player", {
    style: {"width":"100px"},
    src: "/Lottie/tick.json",
    autoplay: ""
  })
], -1))

import { Modal } from "uiv";
import { computed, inject, ref, Ref } from "vue";
import dayjs from "dayjs";
import useTeamLeadLevels, { LevelItem } from "../../composables/useTeamLeadLevels";
import cms from "../../services/cms/cms";
import JyreDatePicker from "../event-log/jyre-date-picker.vue";
import { csContext } from "../../services/cs-context";
import useNotification from "../../composables/useNotification";


export default /*#__PURE__*/_defineComponent({
  __name: 'initiate-request-modal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["close-request-modal"],
  setup(__props: any, { emit: __emit }) {

const level = inject("selectedLevel") as Ref<LevelItem>;

const props = __props;

const emit = __emit;

const isDisplayed = computed(() => {
  return props.modelValue;
});

const { castAsLevel, initiatePathwayFromLevel } = useTeamLeadLevels();
const { notifyTeamMembers } = useNotification();

const requestType = computed(() => {
  return castAsLevel(level.value.data).pathway_to_initiate ? "pathway" : "resource";
});

const modalTitle = computed(() => {
  return requestType.value === "pathway" ? "Initiate pathway" : "Notify team";
});

const notificationText = computed(() => {
  if (requestType.value === "resource") {
    return `${cms.asText(level.value.data.title)}`;
  }

  const pathwayTitle =
    cms.asText(castAsLevel(level.value?.data).pathway_to_initiate?.data?.title) ?? "";

  return `${pathwayTitle} Step 1 & 2`;
});

const successText = computed(() => {
  return requestType.value === "pathway"
    ? "You've successfully initiated the pathway and your team has been notified. You will be able to track their progress from the Team Lead area."
    : "You've successfully notified your team. You will be able to track their progress from the Team Lead area.";
});

const currentDate = dayjs().format("YYYY-MM-DD");
const date = ref(currentDate);
const today = dayjs(currentDate).format("YYYY-MM-DD");

const isSaving = ref(false);
const errorMessage = ref("");
const requestIsInitiated = ref(false);

function closeModal(triggerRefresh: boolean) {
  emit("close-request-modal", triggerRefresh);
}

async function initiatePathway() {
  isSaving.value = true;
  const teamId = csContext.currentTeam?.id;

  if (!teamId) return;

  const parsedLevel = castAsLevel(level.value.data);

  if (parsedLevel.initiate_pathway) {
    try {
      await initiatePathwayFromLevel(parsedLevel, teamId, date.value);

      if (parsedLevel.pathway_type === "personal") {
        await notifyTeamMembers(level.value, teamId, date.value);
      }

      requestIsInitiated.value = true;
      isSaving.value = false;
    } catch (error) {
      errorMessage.value = (error as Error).message;
    } finally {
      isSaving.value = false;
    }
  }
}

async function initiateRequest() {
  if (requestType.value === "pathway") {
    await initiatePathway();
  } else {
    const response = await notifyTeamMembers(level.value, csContext.currentTeam?.id, date.value);
    requestIsInitiated.value = true;
    if (response.error) {
      errorMessage.value = response.error;
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_unref(level))
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        modelValue: isDisplayed.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((isDisplayed).value = $event)),
        header: false,
        footer: false
      }, {
        default: _withCtx(() => [
          (!requestIsInitiated.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h2", _hoisted_2, _toDisplayString(modalTitle.value), 1),
                _createElementVNode("button", {
                  class: "btn btn-close-sm btn-position",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal(false))),
                  type: "button"
                }),
                _createElementVNode("p", null, " Notify your team to complete this " + _toDisplayString(requestType.value === "pathway" ? "pathway" : "resource") + " by using the date-picker below. ", 1),
                _hoisted_3,
                _createElementVNode("div", _hoisted_4, _toDisplayString(notificationText.value), 1),
                _createVNode(JyreDatePicker, {
                  modelValue: date.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((date).value = $event)),
                  class: "date-picker",
                  "limit-from": _unref(today)
                }, null, 8, ["modelValue", "limit-from"]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "btn btn-default-close",
                    type: "button",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (closeModal(false)))
                  }, " Cancel "),
                  _createElementVNode("button", {
                    class: "btn btn-primary-communication",
                    type: "button",
                    onClick: initiateRequest,
                    disabled: isSaving.value,
                    "data-test": "level-send-requests-button"
                  }, " Send ", 8, _hoisted_6)
                ]),
                (errorMessage.value.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errorMessage.value), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("p", null, _toDisplayString(successText.value), 1),
                _hoisted_10,
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = () => closeModal(true)),
                  "data-test": "level-confirm-request-button"
                }, " Close ")
              ]))
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})